export default __webpack_public_path__ + "static/media/halonasoft-logotype-l.10d12e42.svg";